import React from 'react';
import { useAITTheme } from '../ui/theme';

const TripsPlaneIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 473.6 496.29">
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M471.22,333.92l2.25-14.25c.64-4.05-1.11-8.11-4.5-10.42l-190.12-129.85V58.71C267.42,21.99,252.93,0,237.19,0s-30.75,22.82-42.29,60.6v118.79L4.64,309.09c-3.39,2.31-5.15,6.37-4.51,10.42l2.25,14.27c1.02,6.47,7.61,10.48,13.83,8.42l178.7-59.24v130.06l-48.55,44.28c-2.47,2.25-3.73,5.53-3.41,8.86l1.97,20.51c.73,7.63,9.06,11.99,15.74,8.25l71.05-39.71c3.21-1.8,7.13-1.8,10.34,0l70.9,39.49c6.69,3.72,15-.64,15.73-8.26l1.98-20.54c.32-3.32-.94-6.61-3.41-8.86l-48.39-44.17v-130.06l178.52,59.52c6.22,2.08,12.82-1.94,13.84-8.42Z"
      />
    </svg>
  );
};

export default TripsPlaneIcon;
